(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react'), require('@fdn/profile_popup'), require('@fdn/button_login_signup'), require('@fdn/top_menu')) :
  typeof define === 'function' && define.amd ? define('@fdn/sidebar', ['react', '@fdn/profile_popup', '@fdn/button_login_signup', '@fdn/top_menu'], factory) :
  (global = global || self, global['@fdn/sidebar'] = factory(global.React, global.ProfilePopup, global.ButtonLoginSignup, global.TopMenu));
}(this, (function (React, ProfilePopup, ButtonLoginSignup, TopMenu) { 'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;
  ProfilePopup = ProfilePopup && Object.prototype.hasOwnProperty.call(ProfilePopup, 'default') ? ProfilePopup['default'] : ProfilePopup;
  ButtonLoginSignup = ButtonLoginSignup && Object.prototype.hasOwnProperty.call(ButtonLoginSignup, 'default') ? ButtonLoginSignup['default'] : ButtonLoginSignup;
  TopMenu = TopMenu && Object.prototype.hasOwnProperty.call(TopMenu, 'default') ? TopMenu['default'] : TopMenu;

  var Sidebar = function Sidebar(_ref) {
    var is_mobile = _ref.is_mobile,
      logo_img = _ref.logo_img,
      config = _ref.config,
      config_mommies = _ref.config_mommies,
      SisterSites = _ref.SisterSites,
      menu = _ref.menu,
      self = _ref.self,
      is_user_verified = _ref.is_user_verified,
      isShowDownloadApp = _ref.isShowDownloadApp,
      main_link = _ref.main_link,
      reviews_link = _ref.reviews_link,
      sso_link = _ref.sso_link,
      home_link = _ref.home_link,
      close_sidebar = _ref.close_sidebar,
      button_login_id = _ref.button_login_id,
      handle_category_list_sidebar = _ref.handle_category_list_sidebar,
      element_id_category = _ref.element_id_category,
      user_completing_precentage = _ref.user_completing_precentage,
      handleButtonVerif = _ref.handleButtonVerif,
      handleAlloExplorer = _ref.handleAlloExplorer,
      onClickAlloBalance = _ref.onClickAlloBalance,
      onClickAlloPoint = _ref.onClickAlloPoint,
      onClickAlloCoupons = _ref.onClickAlloCoupons,
      type = _ref.type,
      profile_link = _ref.profile_link,
      setting_link = _ref.setting_link,
      logout_link = _ref.logout_link,
      loggedInMenu = _ref.loggedInMenu,
      onClickLoginSignup = _ref.onClickLoginSignup,
      dataDrawer = _ref.dataDrawer,
      handleMenuDrawer = _ref.handleMenuDrawer,
      ActiveMenuDrawer = _ref.ActiveMenuDrawer,
      isShowAllo = _ref.isShowAllo,
      alloBalanceText = _ref.alloBalanceText,
      MPCPointsText = _ref.MPCPointsText,
      MyCouponsText = _ref.MyCouponsText,
      isAlloWalletLoading = _ref.isAlloWalletLoading,
      onClickLogout = _ref.onClickLogout,
      profilePopupCustomElement = _ref.profilePopupCustomElement,
      brandsLink = _ref.brandsLink,
      elementIdBrands = _ref.elementIdBrands,
      onClickBrand = _ref.onClickBrand;
    var props = {
      is_mobile: is_mobile || false,
      logo_img: logo_img || null,
      is_user_verified: is_user_verified || false,
      config: config || [],
      config_mommies: config_mommies || [],
      SisterSites: SisterSites || [],
      menu: menu || {},
      self: self || {},
      main_link: main_link || '',
      reviews_link: reviews_link || '',
      sso_link: sso_link || '',
      logout_link: logout_link || '',
      home_link: home_link || '',
      button_login_id: button_login_id || null,
      element_id_category: element_id_category || null,
      type: type || null,
      user_completing_precentage: user_completing_precentage || 100,
      onClickLoginSignup: onClickLoginSignup || null,
      handleAlloExplorer: handleAlloExplorer || function () {
        return false;
      },
      onClickAlloBalance: onClickAlloBalance || function () {
        return false;
      },
      onClickAlloPoint: onClickAlloPoint || function () {
        return false;
      },
      onClickAlloCoupons: onClickAlloCoupons || function () {
        return false;
      },
      handleButtonVerif: handleButtonVerif || function () {
        return false;
      },
      handle_category_list_sidebar: handle_category_list_sidebar || function () {
        return false;
      },
      close_sidebar: close_sidebar || function () {
        return false;
      },
      handleMenuDrawer: handleMenuDrawer || function () {
        return false;
      },
      profile_link: profile_link || null,
      setting_link: setting_link || null,
      loggedInMenu: loggedInMenu || null,
      dataDrawer: dataDrawer || [],
      ActiveMenuDrawer: ActiveMenuDrawer || [],
      isShowDownloadApp: isShowDownloadApp || false,
      isShowAllo: isShowAllo || false,
      isAlloWalletLoading: isAlloWalletLoading || false,
      alloBalanceText: alloBalanceText || null,
      MPCPointsText: MPCPointsText || null,
      MyCouponsText: MyCouponsText || null,
      onClickLogout: onClickLogout || null,
      profilePopupCustomElement: profilePopupCustomElement || null,
      brandsLink: brandsLink || "#",
      elementIdBrands: elementIdBrands || "id_brands",
      onClickBrand: onClickBrand || undefined
    };
    if (is_mobile) {
      var _props$dataDrawer, _props$dataDrawer2;
      return /*#__PURE__*/React.createElement("div", {
        className: "sidebar"
      }, /*#__PURE__*/React.createElement("div", {
        className: "sidebar-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "logo-content-wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "main-logo-wrapper"
      }, /*#__PURE__*/React.createElement("a", {
        id: props.logo_id,
        href: props.home_link,
        className: !props.logo_img ? 'icon-logo_fd ic-fd' : '',
        "aria-label": "Main Logo"
      }, props.logo_img ? /*#__PURE__*/React.createElement("img", {
        src: props.logo_img,
        alt: "Main Logo"
      }) : null), /*#__PURE__*/React.createElement("style", null, "\n                  .main-logo-wrapper {\n                    width: 112.96px;\n                    overflow: hidden;\n                  }\n          \n                  .main-logo-wrapper a {\n                    display: flex;\n                    position: relative;\n                    font-size: 28px;\n                    height: 28px;\n                  }\n          \n                  .main-logo-wrapper a * {\n                    max-width: 100%;\n                  }\n                ")), /*#__PURE__*/React.createElement("button", {
        className: "btn-close",
        onClick: props.close_sidebar,
        "aria-label": "Button Close"
      }, /*#__PURE__*/React.createElement("img", {
        src: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/ic-close.svg",
        width: "12",
        className: "ic-object",
        alt: "ic-close"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "profile-content-wrapper"
      }, !!props.self.id ? /*#__PURE__*/React.createElement(ProfilePopup, {
        is_mobile: true,
        fullname: props.self.fullname,
        profile_image: props.self.picture.small,
        email: props.self.email,
        is_verified: props.is_user_verified,
        profile_link: props.profile_link,
        setting_link: "".concat(props.profile_link, "/my/account"),
        logout_link: "".concat(props.sso_link, "/logout"),
        customContent: props.profilePopupCustomElement
      }) : /*#__PURE__*/React.createElement(ButtonLoginSignup, {
        is_mobile: true,
        text: "Login or Signup",
        link: props.sso_link,
        element_id: props.button_login_id,
        type: props.type,
        onClick: props.onClickLoginSignup
      })), /*#__PURE__*/React.createElement("div", {
        className: "navigation-wrapper"
      }, ((_props$dataDrawer = props.dataDrawer) === null || _props$dataDrawer === void 0 || (_props$dataDrawer = _props$dataDrawer.data) === null || _props$dataDrawer === void 0 || (_props$dataDrawer = _props$dataDrawer.data) === null || _props$dataDrawer === void 0 ? void 0 : _props$dataDrawer.length) > 1 ? (_props$dataDrawer2 = props.dataDrawer) === null || _props$dataDrawer2 === void 0 || (_props$dataDrawer2 = _props$dataDrawer2.data) === null || _props$dataDrawer2 === void 0 ? void 0 : _props$dataDrawer2.data.map(function (item) {
        return /*#__PURE__*/React.createElement("div", {
          key: item.post_id
        }, item.child.length > 0 ? /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "accordion left",
          onClick: function onClick() {
            return props.handleMenuDrawer({
              pos: 0,
              id: item.post_id
            });
          }
        }, item.title, ' ', /*#__PURE__*/React.createElement("img", {
          className: "ic-chevron-down",
          src: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/chevron-down.svg"
        })) : /*#__PURE__*/React.createElement("a", {
          href: item.url,
          className: "accordion left"
        }, item.title), /*#__PURE__*/React.createElement("div", {
          className: props.ActiveMenuDrawer && props.ActiveMenuDrawer.includes(item.post_id) ? 'panel show' : 'panel'
        }, item.child.map(function (itemx) {
          return /*#__PURE__*/React.createElement("div", {
            key: itemx.post_id
          }, itemx.child.length > 0 ? /*#__PURE__*/React.createElement("button", {
            type: "button",
            className: "accordion",
            onClick: function onClick() {
              return props.handleMenuDrawer({
                pos: 1,
                id: itemx.post_id
              });
            }
          }, itemx.title, ' ', /*#__PURE__*/React.createElement("img", {
            className: "ic-chevron-down",
            src: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/chevron-down.svg"
          })) : /*#__PURE__*/React.createElement("a", {
            href: itemx.url,
            className: "accordion"
          }, itemx.title), /*#__PURE__*/React.createElement("div", {
            className: props.ActiveMenuDrawer && props.ActiveMenuDrawer.includes(itemx.post_id) ? 'panel show' : 'panel'
          }, itemx.child.map(function (itemxx) {
            return /*#__PURE__*/React.createElement("div", {
              key: itemxx.post_id
            }, /*#__PURE__*/React.createElement("a", {
              href: itemxx.url,
              className: "accordion"
            }, itemxx.title));
          })));
        })));
      }) : null, props.main_link.includes('review') && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
        id: props.element_id_category,
        onClick: props.handle_category_list_sidebar,
        className: "accordion"
      }, "CATEGORY", /*#__PURE__*/React.createElement("span", {
        className: "fdicon-bs-chevron-right"
      })), /*#__PURE__*/React.createElement("a", {
        id: props.elementIdBrands,
        href: props.brandsLink,
        className: "accordion",
        onClick: onClickBrand
      }, "BRANDS"), /*#__PURE__*/React.createElement("a", {
        href: self.id ? "".concat(props.main_link, "/user/").concat(props.self.username, "/feeds") : props.sso_link,
        className: "accordion"
      }, "FEED"), props.self.id && props.user_completing_precentage !== 100 ? /*#__PURE__*/React.createElement("a", {
        onClick: handleButtonVerif
      }, "PRODUCT MATCHES") : /*#__PURE__*/React.createElement("a", {
        href: props.self.id && props.user_completing_precentage == 100 ? 'product-matches' : sso_link,
        className: "accordion"
      }, "PRODUCT MATCHES")), !!props.config && config.map(function (item, idx) {
        return /*#__PURE__*/React.createElement("a", {
          id: item.element_id ? "".concat(item.element_id) : null,
          href: "".concat(item.pathname, "?").concat(item.query),
          key: idx,
          className: "accordion"
        }, item.name, !!item["new"] ? /*#__PURE__*/React.createElement("span", {
          className: "label-new"
        }, "NEW") : null);
      }), props.isShowDownloadApp ? /*#__PURE__*/React.createElement("a", {
        href: props.is_mobile.toString().toLowerCase() == 'iphone' ? 'https://itunes.apple.com/id/app/female-daily-beauty-review/id1160742672?l=id' : 'https://play.google.com/store/apps/details?id=com.fdbr.android&hl=en_GB'
      }, "DOWNLOAD FEMALE DAILY APP") : null)), !!props.self.id ? /*#__PURE__*/React.createElement("div", {
        className: "sidebar-content"
      }, props.loggedInMenu ? props.loggedInMenu : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "profile-option"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: props.handleAlloExplorer,
        id: "id_allodropdown"
      }, /*#__PURE__*/React.createElement("img", {
        src: "https://image.femaledaily.com/web-assets/allo_explore_black.png",
        className: "allo-image"
      }), /*#__PURE__*/React.createElement("p", null, "Allo Explore"))), /*#__PURE__*/React.createElement("div", {
        className: "profile-option"
      }, /*#__PURE__*/React.createElement("a", {
        href: props.setting_link,
        id: "id_settingdropdown"
      }, /*#__PURE__*/React.createElement("div", {
        className: "new-icon"
      }, /*#__PURE__*/React.createElement("img", {
        src: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/ic-setting.svg",
        width: "12",
        className: "ic-object",
        alt: "ic-setting",
        "aria-label": "Button Setting"
      })), /*#__PURE__*/React.createElement("p", null, "Settings"))), /*#__PURE__*/React.createElement("div", {
        className: "profile-option"
      }, props.onClickLogout ? /*#__PURE__*/React.createElement("button", {
        className: "option-menu",
        onClick: function onClick() {
          return props.onClickLogout();
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "new-icon"
      }, /*#__PURE__*/React.createElement("img", {
        src: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/ic-logout.svg",
        width: "12",
        className: "ic-object",
        alt: "ic-logout",
        "aria-label": "Button Logout"
      })), /*#__PURE__*/React.createElement("p", null, "Logout")) : /*#__PURE__*/React.createElement("a", {
        href: "".concat(props.logout_link || props.sso_link + '/logout'),
        id: "id_logoutdropdown"
      }, /*#__PURE__*/React.createElement("div", {
        className: "new-icon"
      }, /*#__PURE__*/React.createElement("img", {
        src: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/ic-logout.svg",
        width: "12",
        className: "ic-object",
        alt: "ic-logout",
        "aria-label": "Button Logout"
      })), /*#__PURE__*/React.createElement("p", null, "Logout"))))) : null, !!props.config_mommies && config_mommies ? /*#__PURE__*/React.createElement("div", {
        className: "sidebar-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-wrapper menu-mommies"
      }, config_mommies.map(function (item, idx) {
        return /*#__PURE__*/React.createElement("a", {
          id: item.element_id ? "".concat(item.element_id) : null,
          href: "".concat(item.pathname, "?").concat(item.query),
          key: idx,
          className: "accordion"
        }, item.name, !!item["new"] ? /*#__PURE__*/React.createElement("span", {
          className: "label-new"
        }, "NEW") : null);
      }))) : null, /*#__PURE__*/React.createElement("div", {
        className: "sidebar-content"
      }, props.main_link.includes('review') || props.main_link.includes('talk') ? /*#__PURE__*/React.createElement("div", {
        className: "menu-wrapper"
      }, /*#__PURE__*/React.createElement("p", {
        className: "content-title"
      }, "Female Daily"), /*#__PURE__*/React.createElement(TopMenu, {
        is_mobile: props.is_mobile,
        title_menu: props.menu.title_menu,
        menus: props.menu.menus
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "menu-wrapper"
      }, /*#__PURE__*/React.createElement("p", {
        className: "content-title"
      }, "Our Sister Sites"), !!props.SisterSites && props.SisterSites.map(function (item) {
        return /*#__PURE__*/React.createElement("a", {
          id: item.value ? "".concat(item.value) : null,
          href: "".concat(item.pathname, "?").concat(item.query),
          key: item.value
        }, item.name, !!item["new"] ? /*#__PURE__*/React.createElement("span", {
          className: "label-new"
        }, "NEW") : null);
      }))), /*#__PURE__*/React.createElement("style", null, "\n            .new-icon {\n              display: flex;\n              justify-content: center;\n              align-items: center;\n              width: 28px;\n              height: 28px;\n            }\n            .ic-object {\n              pointer-events: none;\n            }\n            .sidebar {\n              position: fixed;\n              top: 0;\n              left: 0;\n              width: 100vw;\n              height: 100vh;\n              overflow-y: scroll;\n              background-color: #FFF;\n            }\n\n            .sidebar-content {\n              padding: 10px 24px;\n              background-color: #FFF;\n              border-bottom: 12px solid #F0F3F7;\n            }\n\n            .navigation-wrapper{\n              display: flex;\n              flex-flow: column;\n              padding: 18px 0;\n            }\n\n            .navigation-wrapper a span{\n              height: 13px;\n              margin-top: -8px;\n            }\n\n            .fdicon-bs-chevron-right{\n              float: right;\n              font-size: 20px;\n\n            }\n\n            .menu-mommies{\n              margin-top: 12px;\n            }\n\n            .label-new{\n              color: rgb(255, 255, 255);\n              font-size: 10px;\n              // position: absolute;\n              font-family: Poppins;\n              margin-left: 5px;\n              background: rgb(215, 36, 78);\n              padding: 2px 4px;\n              border-radius: 4px;\n            }\n\n            .navigation-wrapper .label-new {\n              height: unset !important;\n              margin-top: unset !important;\n            }\n\n            // .navigation-wrapper a{\n            //   font-family: Poppins !important;\n            //   font-style: normal;\n            //   font-weight: 500;\n            //   font-size: 12px;\n            //   margin-bottom: 15px;\n            //   color: #000;\n            //   text-decoration: none;\n            //   letter-spacing: 0.08em;\n            // }\n\n            .sidebar-content:nth-last-child(2) {\n              border-bottom: none;\n            }\n\n            .sidebar .logo-content-wrapper {\n              display: flex;\n              align-items: center;\n              justify-content: space-between;\n              margin-bottom: 16px;\n            }\n\n            .sidebar .btn-close {\n              background: none;\n              border: none;\n            }\n\n            .sidebar-content .btn-close * {\n              font-size: 24px;\n            }\n\n            .sidebar-content .btn-close *::before {\n              display: block;\n            }\n\n            .sidebar .profile-content-wrapper {\n              padding: 16px 0;\n              border: 1px solid #DFE3E8;\n              border-width: 1px 0;\n              display: flex;\n            }\n\n            .sidebar .btn-login {\n              text-transform: uppercase;\n            }\n\n            .sidebar .profile-option {\n              display: flex;\n              align-items: center;\n              margin-bottom: 12px;\n            }\n\n            .sidebar .profile-option a,\n            .sidebar .profile-option button {\n              display: flex;\n              color: #000;\n              text-decoration: none;\n            }\n\n            .sidebar .profile-option button {\n              padding: 0;\n              background-color: transparent;\n              border: none;\n            }\n\n            .sidebar .profile-option:nth-last-child(1) {\n              margin-bottom: 0;\n            }\n\n            .sidebar .profile-option p {\n              font-family: Poppins, sans-serif;\n              font-size: 12px;\n              line-height: 28px;\n              font-weight: 500;\n              letter-spacing: 0.08em;\n              text-transform: uppercase;\n              margin: 0 0 0 12px;\n            }\n\n            .sidebar .profile-option .allo-image{\n              width: 28px;\n            }\n\n            .sidebar .menu-wrapper {\n              margin-bottom: 24px;\n            }\n\n            .sidebar .menu-wrapper:nth-last-child(1) {\n              margin-bottom: 0;\n            }\n\n            .sidebar .menu-wrapper .content-title {\n              font-family: Roboto;\n              font-weight: normal;\n              font-size: 12px;\n              color: #919EAB;\n              margin: 0 0 10px 0;\n            }\n\n            .sidebar .menu-wrapper a {\n              font-family: Poppins, sans-serif;\n              font-style: normal;\n              font-weight: normal;\n              font-size: 12px;\n              line-height: 100%;\n              color: #000000;\n              margin: 0 0 12px 0;\n              display: block;\n              text-decoration: none;\n            }\n\n            // burger menu\n            button {\n              outline: none;\n            }\n            .accordion {\n              color: #000;\n              background: none;\n              cursor: pointer;\n              padding: 4px 0;\n              width: 100%;\n              border: none;\n              outline: none;\n              text-transform: uppercase;\n              margin: 0;\n              font-family: Poppins;\n              font-size: 12px;\n              font-weight: 600;\n              line-height: 28px;\n              letter-spacing: 0.08em;\n              text-align: left;\n              font-weight: 600 !important;\n              display: flex;\n              align-items: center;\n              gap: var(--fd-space-2);\n              justify-content: space-between;\n            }\n            .left {\n              padding-left: 0;\n            }\n    \n            .link {\n              margin: 0;\n              cursor: pointer;\n              padding: 4px 18px;\n              width: 100%;\n              border: none;\n              text-align: left;\n              outline: none;\n              // transition: 0.4s;\n              background-color: #fff; \n              text-transform: uppercase;\n              text-decoration: none;\n              color: #000;\n              font-family: Poppins;\n              font-size: 12px;\n              font-weight: 600;\n              line-height: 28px;\n              letter-spacing: 0.08em;\n              text-align: left;\n            }\n            \n            .active, .accordion:hover {\n              // background-color: #ccc; \n            }\n            \n            .panel {\n              padding: 0 0 0 18px;\n              transition: all .3s ease-out;\n              overflow: hidden;\n              visibility: hidden;\n              opacity: 0;\n              height: 0;\n            }\n            .panel.show {\n              visibility: visible;\n              opacity: 1;\n              height: auto;\n            }\n            .ic-chevron-down {\n              height: 12.5px;\n              width: 13px;\n            }\n        "));
    }
  };

  return Sidebar;

})));
//# sourceMappingURL=sidebar.umd.js.map
